import { render, staticRenderFns } from "./OrderingField.vue?vue&type=template&id=19bc4b3c&"
import script from "./OrderingField.vue?vue&type=script&lang=ts&"
export * from "./OrderingField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports